<template>
  <!-- 卡片（电源控制器） -->
  <div class="gz-swiper popout" v-loading.fullscreen.lock='loading' element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
<!-- 列表 -->
      <div class="search-item">
          <el-input class="myinput" size="small" suffix-icon="el-icon-search" placeholder="请输入电源控制器名称/编号" v-model="searchForm.powerNameNo"></el-input>
          <el-select class="element-list" size="small" clearable :poper-append-to-body="false" popper-class="my-select" v-model="searchForm.bindState" placeholder="请选择绑定状态">
            <el-option v-for="item in bdOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
          <el-select class="element-list" size="small" clearable :poper-append-to-body="false" popper-class="my-select" v-model="searchForm.type" placeholder="请选择电源控制器类型">
            <el-option v-for="item in kzqOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
          <div class="my-buttom select-buttom search-button" @click="inquire">
            查询
          </div>
          <div class="my-buttom tit-button" @click="reset">重置</div> 
        </div>
      <div class="table_cm">
        <el-table
      :data="PowerInfo"
      style="width: 100%"
      height="740" element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column
            prop="serialNumber"
            label="编号"
            align="center"
            width="85"
          >
          </el-table-column>
          <el-table-column
            prop="serialNumber"
            label="功率"
            align="center"
            width="85"
          >
          <template slot-scope="{row}">
          <span>{{row.power}} KW</span>
        </template>
         
          </el-table-column>
          <el-table-column
            prop="serialNumber"
            label="电压"
            align="center"
            width="85"
          >
          <template slot-scope="{row}">
          <span>{{row.electric}} V</span>
        </template> 
          </el-table-column>
          <el-table-column
            prop="switchName"
            label="电源控制器名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="type"
            label="电源类型"
            align="center"
          >
          <template slot-scope="{row}">
            {{ row.type==1?'智能插座':'大型电源控制器' }}
          </template>  
          </el-table-column>
          <el-table-column
            label="二维码"
            align="center"
          >
          <template slot-scope="{row}">
            <img :src="row.qrCodeUrl" alt style="    width: 100px;
    height: 100px;" />
        </template>  
          </el-table-column>
          <el-table-column
            label="绑定仪器"
            align="center"
          >
          <template slot-scope="scope">
                <div class="kzq_unbind bottom-right">
                <div v-for="(insItem,insIndex) in scope.row.insLst" :key="insIndex">
                  <span>绑定仪器：{{ insItem.instrumentName }}</span>
                  <el-button type="text" icon="el-icon-circle-close" circle @click="unbindPower(insItem.id)"></el-button>
                </div>
              </div>
              </template>
          </el-table-column>
         
          <el-table-column
            prop="bindState"
            label="绑定状态"
            align="center"
          >
          <template slot-scope="{row}">
            <span :class="row.bindState==1? 'bindState-ybd':'bindState-wbd'">{{ row.bindState==0?'未绑定':'已绑定' }}</span>
          </template>  
          </el-table-column>
          <el-table-column
            label="状态"
            align="center"
            width="80"
          >
          <template slot-scope="scope">
            <el-switch v-model="scope.row.states"  active-color="#75C8FE" inactive-color="#09467D" :active-value="1" 
            :inactive-value="0" @change=changSwitch($event,scope.row.id)></el-switch>
          </template>
          </el-table-column>
      
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="180"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click.native.prevent="bindPower(scope.row.id)" v-if="(scope.row.type==1&&scope.row.bindState==0)||scope.row.type!=1">绑定</el-button>
              <el-button type="text" size="small" @click.native.prevent="editPower(scope.$index)">编辑</el-button>
              <el-button type="text" size="small" style="color: red;" @click.native.prevent="delPower(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
          
        </el-table>
      </div>
    <div class="resource-block" v-if="PowerInfo.length>0">
      <el-pagination background prev-text="前一页" next-text="后一页" layout="prev, pager, next" :total="total" :current-page.sync="currentPage" :page-size="pageSize" @current-change="pageChange"></el-pagination>
    </div>
    <!-- 电源控制器修改 -->
    <div class="addModel myDialog">
      <el-dialog title="" :visible.sync="editVisible" v-if="editVisible" width="500px">
        <editPower @cancel="cancel" @submit="submitPower" ref="editmodel" :pInfo='pInfo'></editPower>
      </el-dialog>
    </div>
    <!-- 电源控制器绑定仪器 -->
    <div class="addModel myDialog">
      <el-dialog title="绑定仪器" :visible.sync="pbindVisible" v-if="pbindVisible" width="400px">
        <instrumentList @pcheckValue="pcheckValue" @cancel="cancel"></instrumentList>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import addTemperature from "./addTemperature";
import editPower from "./editPower";
import instrumentList from "./instrumentList";
import Table from "@/components/myTable";
import {
  PowerOn,
  PowerOff,
  deletePower,
  powerBind,
  powerUnbind,
  powerUpdate,
  getPowerList,
} from "@/api/warehouse";
import constants from "@/assets/data/common";
export default {
  name: "powerSwiper",
  components: {
    addTemperature,
    editPower,
    instrumentList,
  },
  props: {
    depotInfo: {
      type: Object,
      default: {},
    },
  },
  inject: ["reload"],
  data() {
    return {
      cloumns: [],
      editVisible: false, //电源控制器修改弹窗
      pbindVisible: false, //电源控制器绑定仪器弹窗
      show: "", //是否显示选中效果
      pInfo: "", //选中电源控制器信息
      powerId: "", //选中电源控制器的id
      depotId: "", //仓库id
      PowerInfo: [], //电源控制器列表
      currentPage: 1, //当前页数
      pageSize: 10, //每页显示数量
      total: 0, //总数
      loading: false,
      bdOptions: constants.BindingState, 
      kzqOptions: constants.ControllerType, 
      searchForm:{
        powerNameNo:null,
      bindState:null,
      type:null
      }
    }
  },
  watch: {
    depotInfo: {
      handler(val) {
        this.depotId = val.id;
        this.getPowerList();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
      // 点击页码操作
      handleCurrentChange(val) {
      this.currentPage = val;
      this.getPowerList();
    },
    inquire(){
      this.currentPage = 1;
      this.getPowerList();
    },
     reset(){
      this.searchForm ={
        powerNameNo:null,
      bindState:null,
      type:null
      }
      this.currentPage = 1;
      this.getPowerList();
     },
    //获取电源控制器信息
    getPowerList() {
      let params = {
        depotId: this.depotId,
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm
      };
      this.loading = true;
      getPowerList(params)
        .then((res) => {
          if (res.code == 200) {
            this.PowerInfo = res.data.records;
            this.total = res.data.total;
          } else {
            this.PowerInfo = [];
            this.$message.error(res.msg || "网络请求错误");
          }
          this.loading = false;
        })
        .catch((err) => {
          this.PowerInfo = [];
          this.loading = false;
          this.$message.error(err.msg || err.message || "网络请求错误");
        });
    },
    //电源控制器状态切换
    changSwitch(e, id) {
      // e为改变后的状态值1/0，id为当前修改对象的id
      let state = e;
      if (state == 1) {
        PowerOn(id).then((res) => {
          if (res.code == "200") {
            this.$message.success("控制器已开启");
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        PowerOff(id).then((res) => {
          if (res.code == "200") {
            this.$message.warning("控制器已关闭");
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 电源控制器编辑提交
    submitPower(data) {
      this.editVisible = false;
      let params = { ...data };
      powerUpdate(params).then((res) => {
        if (res.code == "200") {
          this.$message.success("修改电源控制器信息成功！");
          this.getPowerList();
        } else {
          this.$message.error("修改电源控制器信息失败", res.msg);
        }
      });
    },
    //分页功能
    pageChange(page) {
      this.currentPage = page;
      this.getPowerList();
    },
    // 电源控制器编辑
    editPower(index) {
      this.pInfo = this.PowerInfo[index];
      this.editVisible = true;
    },
    // 电源控制器删除
    delPower(pid) {
      this.$confirm("确定删除该电源控制器吗？", "删除提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      })
        .then(() => {
          deletePower(pid).then((res) => {
            if (res.code == "200") {
              this.$message.success("删除成功!");
              this.getPowerList();
            } else {
              this.$message.error("删除失败！" + res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 电源控制器取消绑定仪器
    unbindPower(instrumentId) {
      this.$confirm("确定解绑该仪器吗？", "解绑提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      })
        .then(() => {
          powerUnbind(instrumentId).then((res) => {
            if (res.code == "200") {
              this.$message.success("解绑成功！");
              this.getPowerList();
            } else {
              this.$message.error("解绑失败");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消解绑操作",
          });
        });
    },
    // 电源控制器绑定仪器弹窗
    bindPower(pid) {
      this.powerId = pid;
      this.pbindVisible = true;
    },
    // 电源控制器绑定仪器提交
    pcheckValue(val) {
      this.pbindVisible = false;
      let params = {
        powerId: this.powerId,
        InstrumentId: val,
      };
      powerBind(params).then((res) => {
        if (res.code == "200") {
          this.$message.success("绑定成功！");
          this.getPowerList();
        } else {
          this.$message.error("绑定失败！");
        }
      });
    },
    cancel() {
      this.editVisible = false;
      this.pbindVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/commonStyle.less";

.resource-block {
  text-align: center;
}
.bindState-ybd{
  color: #3177EC
  
}
.bindState-ybd::before{
  content: '';
  width: 8px;
  display: inline-block;
  height: 8px;
  background-color: #3177EC;
  border-radius: 50%;
  margin-right: 3px;
}
.bindState-wbd::before{
  content: '';
  width: 8px;
  display: inline-block;
  height: 8px;
  background-color: #ccc;
  border-radius: 50%;
  margin-right: 3px;
}
.search-item {
      width: 100%;
      margin-top: 10px;
      margin-bottom: 10px;
      .myinput {
        width: 300px;
      }
      .element-list {
        border: 2px solid #0090f0;
        border-radius: 6px;
        height: 30px;
        width: 150px;
        line-height: 30px;
        text-align: center;
        /deep/ .el-input__inner {
          background-color: rgba(0, 0, 0, 0);
          color: #fff;
          border: 0px;
          border-radius: 0px;
          text-align: center;
        }
        /deep/ input::-webkit-input-placeholder {
          color: #74c8fe;
        }
        /deep/ input::-moz-input-placeholder {
          color: #74c8fe;
        }
        /deep/ input::-ms-input-placeholder {
          color: #74c8fe;
        }
      }
    }
//温湿度样式
.kzq {
  .card-list {
    width: 100%;
    height: 730px;
    /deep/ [class^="el-icon-"] {
      font-size: 20px;
    }
    /deep/.el-switch__core:after {
      background-color: #718cd9;
      width: 13px;
      height: 13px;
    }
    /deep/.el-switch__core {
      border-color: #67baf0 !important;
      width: 47px;
      height: 17px;
    }
    /deep/.el-switch.is-checked .el-switch__core::after {
      left: 100%;
      margin-left: -14px;
    }
    .yq-card-item {
      width: 32.3333%;
      float: left;
      box-sizing: border-box;
      margin-bottom: 10px;
      margin-left: 1%;
      height: 350px;
      border: 2px solid#0090F0;
      box-shadow: 0 0 33px#0090F0 inset;
      border-radius: 4px;
      .equip-item-top {
        width: 100%;
        height: 40%;
        padding: 10px;
        box-sizing: border-box;
        background: linear-gradient(
          180deg,
          rgba(0, 210, 255, 0.52),
          rgba(0, 57, 142, 0.52)
        );
        display: flex;
        .top-left {
          width: 35%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .ico-power {
            font-size: 80px;
            text-align: center;
            color: #75c8fe;
            margin-bottom: 10px;
          }
        }
        .top-right {
          width: 65%;
          height: 100%;
          .el-button.is-circle {
            padding: 0;
          }
          div {
            height: 40px;
            line-height: 40px;
          }
          .top-name {
            display: flex;
            justify-content: space-between;
            .power-name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .power-edit {
              width: 30px;
              text-align: end;
            }
          }
          .top-pw {
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          }
        }
      }
      .equip-item-bottom {
        width: 100%;
        height: 60%;
        background: rgba(8, 19, 41, 0.5);
        box-shadow: 0 0 15px #0071f1 inset;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        .bottom-left {
          box-sizing: border-box;
          width: 40%;
          padding: 15px;
          img {
            width: 160px;
            height: 160px;
          }
        }
        .bottom-right {
          width: 60%;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          height: 40px;
          line-height: 40px;
          .el-button.is-circle {
            padding: 0;
          }
          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}

.not_info {
  margin: 0 auto;
  margin-top: 20px;
  width: 1570px;
  color: #74c8fe;
  font-size: 24px;
  text-align: center;
  .info_text {
    margin-top: 320px;
  }
}
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/powerSwiper.vue